export default {
  SET_MODULES_HML_VERSION: 'SET_MODULES_HML_VERSION',
};
